export function iconWidth(icons, conditionalEditIcon) {
  let iconCount = 0;
  if (icons) {
    iconCount = icons.length;
  }

  let width = 100;
  switch (iconCount) {
    case 1:
      width = 30;
      break;
    case 2:
      width = 75;
      break;
    default:
      width = 100;
      break;
  }

  if (conditionalEditIcon) {
    width = 75;
  }

  return width;
}
